import React from "react";
import PostListPage from "@/pages/PostListPage";

export default function BlogPage() {
    return (
        <PostListPage
            type="blog"
            kicker="Insights"
            title="Analysis for risk leaders."
            description="Case notes, method and market shifts across corporate security, cyber, TSCM and investigations."
        />
    );
}
